const classes = {
  root: {
    color: "#fff",
    "&.MuiBackdrop-root": {
      backgroundColor: "rgba(0,0,0,0.8) !important",
    },
    "& .MuiButtonBase-root": {
      color: "#fff",
      zIndex: 99999,
      "& .MuiSvgIcon-root": {
        width: "48px",
        height: "48px",
      },
    },
    "& p": {
      maxWidth: "70vw",
      textAlign: "justify",
      color: "#FFF",
    },
    "& img": {
      maxHeight: "95vh",
    },
  },
  closeIcon: {
    position: "absolute",
    top: "20px",
    right: "20px",
  },
};
export default classes;
